module.exports = __webpack_public_path__ + "img/star2-new.fe347be0.png";